import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface Feedback {
  response: string
  hireStatus: string
}

interface MessageQueue {
  type: string
  message: string
}

export enum DsmlSqlJudgeActiveStage {
  testInstructions = "test-instructions",
  interviewSetup = "interview-setup",
  dsmlSqlQuery = "sql-query-test",
  dsmlSqlTheory = "sql-theory-test",
  disqualification = "disqualification",
  continueSession = "continue-session",
  review = "review",
}

export const DSML_SQL_STAGE_MAP: Record<string, DsmlSqlJudgeActiveStage> = {
  "sql-query-test": DsmlSqlJudgeActiveStage.dsmlSqlQuery,
  "sql-theory-test": DsmlSqlJudgeActiveStage.dsmlSqlTheory,
}

interface DsmlSqlJudgeState {
  activeStage: DsmlSqlJudgeActiveStage
  editorValue: string | null
  isUserSpeaking: boolean
  feedback: Feedback | null
  sessionId: string | null
  messageQueue: MessageQueue[]
  problemDescription: string
}

const initialState: DsmlSqlJudgeState = {
  activeStage: DsmlSqlJudgeActiveStage.testInstructions,
  editorValue: null,
  feedback: null,
  isUserSpeaking: false,
  sessionId: null,
  messageQueue: [],
  problemDescription: "",
}

const DsmlSqlJudgeSlice = createSlice({
  name: "dsml-sql-judge",
  initialState,
  reducers: {
    setActiveStage: (state, action: PayloadAction<DsmlSqlJudgeActiveStage>) => {
      state.activeStage = action.payload
    },
    setEditorValue: (state, action: PayloadAction<string | null>) => {
      state.editorValue = action.payload
    },
    setFeedback: (state, action: PayloadAction<Feedback>) => {
      state.feedback = action.payload
    },
    setIsUserSpeaking: (state, action: PayloadAction<boolean>) => {
      state.isUserSpeaking = action.payload
    },
    setSessionId: (state, action: PayloadAction<string | null>) => {
      state.sessionId = action.payload
    },
    setMessageQueue: (state, action: PayloadAction<MessageQueue[]>) => {
      state.messageQueue = action.payload
    },
    setProblemDescription: (state, action: PayloadAction<string>) => {
      state.problemDescription = action.payload
    },
    resetState: () => initialState,
  },
})

export const {
  setMessageQueue,
  setEditorValue,
  setFeedback,
  setSessionId,
  setIsUserSpeaking,
  setActiveStage,
  setProblemDescription,
  resetState,
} = DsmlSqlJudgeSlice.actions
export default DsmlSqlJudgeSlice.reducer
